define('viewmodels/survey/WorkflowConfigure',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/app', 'durandal/system', 'services/appsecurity', 'viewmodels/GeneralSettings', 'services/utils'],
    function (ko, router, navigation, logger, app, system, appsecurity, ObjGeneralSettings, utils) {
        var WfViewModel = {
            attached: attached,
            detached: function () {},
            activate: function () {},
            utils: utils,
            appsecurity: appsecurity,
            ObjGeneralSettings: ObjGeneralSettings,
            ControlsAccess: ko.observable(false),
            LocaleCheckFlag: ko.observable(false),

            workflowTypes: ko.observable(),
            selectedWorkflowType: ko.observable(),
            GetWorkflowDetails: GetWorkflowDetails,
            workflowDetails: ko.observable(),
            StageDetails: ko.observable(),
            ActionDetails: ko.observable()
    };
    return WfViewModel;

        function attached() {
            try {
                if (appsecurity.isConfigurationFreeze() === undefined) {
                    appsecurity.GetConfigurationFreezeFlag().then(function () {
                        if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                            WfViewModel.ControlsAccess(true);
                        }
                        else {
                            WfViewModel.ControlsAccess(false);
                        }
                    });

                    if (WfViewModel.ObjGeneralSettings === undefined || WfViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((WfViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || WfViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && WfViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                        WfViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                            if (WfViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || WfViewModel.ObjGeneralSettings.LocalizedTextList() == null || WfViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || WfViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || WfViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                                WfViewModel.LocaleCheckFlag(false);
                            else
                                WfViewModel.LocaleCheckFlag(true);
                        });
                    }
                    else {
                        if (WfViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || WfViewModel.ObjGeneralSettings.LocalizedTextList() == null || WfViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || WfViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || WfViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            WfViewModel.LocaleCheckFlag(false);
                        else
                            WfViewModel.LocaleCheckFlag(true);
                    }
                }
                else if (appsecurity.WriteAccess() && !appsecurity.isConfigurationFreeze()) {
                    WfViewModel.ControlsAccess(true);
                }
                else {
                    WfViewModel.ControlsAccess(false);
                }
                GetWorkflowTypes();                
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in WorkflowConfigure.js';
                logger.logMessage(msg);
            }
        }

        function GetWorkflowChart(nodes, links) {
            $(".chartContainer").html('');
            if (nodes != undefined && nodes != "" && nodes.length > 0 && links != undefined && links != "" && links.length > 0) {
                var arcData = {
                    "nodes": nodes,
                    "links": links
                }

                arcDiagram(arcData);

                //Mock data - not to be deleted 

                //Nodes index starts from 0, links - source is nodes index
                //var arcData = {
                //    "nodes": [
                //        { "cls": 0, "Name": "Not Started","color": "gray" },
                //        { "cls": 1, "Name": "Responder 1","color": "red"},
                //        { "cls": 2, "Name": "Responder 2","color": "green"},
                //        { "cls": 3, "Name": "Reviewer 1", "color": "orange"},
                //        { "cls": 4, "Name": "Reviewer 2", "color": "blue"},
                //        { "cls": 5, "Name": "Completed", "color": "#ec00c7"}
                //    ],
                //    "links": [
                //        { "source": 0, "target": 1 },

                //        { "source": 1, "target": 0 },
                //        { "source": 1, "target": 2 },

                //        { "source": 2, "target": 3 },
                //        { "source": 2, "target": 0 },
                //        { "source": 2, "target": 1 },
                //        { "source": 2, "target": 4 },

                //        { "source": 3, "target": 4 },
                //        { "source": 3, "target": 0 },
                //        { "source": 3, "target": 1 },
                //        { "source": 3, "target": 2 },
                //        { "source": 3, "target": 5 },

                //        { "source": 4, "target": 5 },
                //        { "source": 4, "target": 0},
                //        { "source": 4, "target": 1 },
                //        { "source": 4, "target": 2 },
                //        { "source": 4, "target": 3 },

                //        { "source": 5, "target": 4 },
                //        { "source": 5, "target": 0 }
                //    ]
                //}
            }
        }




      
        /* HELPER FUNCTIONS */

        // Generates a tooltip for a SVG circle element based on its ID
        function addTooltip(circle) {
            var width = 960;           // width of svg image
            var height = 400;           // height of svg image
            var margin = 20;            // amount of margin around plot area
            var pad = margin / 2;       // actual padding amount
            var radius = 4;             // fixed node radius
            var yfixed = pad + radius;  // y position for all nodes

            var x = parseFloat(circle.attr("cx"));
            var y = parseFloat(circle.attr("cy"));
            var r = parseFloat(circle.attr("r"));
            var text = circle.attr("id");

            var tooltip = d3.select("#plot")
                .append("text")
                .text(text)
                .attr("x", x)
                .attr("y", y)
                .attr("dy", -r * 2)
                .attr("id", "tooltip");

            var offset = tooltip.node().getBBox().width / 2;

            if ((x - offset) < 0) {
                tooltip.attr("text-anchor", "start");
                tooltip.attr("dx", -r);
            }
            else if ((x + offset) > (width - margin)) {
                tooltip.attr("text-anchor", "end");
                tooltip.attr("dx", r);
            }
            else {
                tooltip.attr("text-anchor", "middle");
                tooltip.attr("dx", 0);
            }
        }

        function highlightTip(cls) {
            d3.selectAll("." + cls)
                .style("filter", "url(#glow)");
        }
        function remhighlightTip(cls) {
            d3.selectAll("." + cls)
                .style("filter", "");
        }
        /* MAIN DRAW METHOD */

        // Draws an arc diagram for the provided undirected graph
        function arcDiagram(graph) {
            var width = 980;           // width of svg image
            var height = 540;           // height of svg image
            var margin = 20;            // amount of margin around plot area
            var pad = margin / 2;       // actual padding amount
            var radius = 30;             // fixed node radius
            var yfixed = pad + radius;  // y position for all nodes

            // create svg image
            var svg = d3.select(".chartContainer")
                .append("svg")
                .attr("id", "arc")
                .attr("width", width)
                .attr("height", height);

            // draw border around svg image
             svg.append("rect")
                 .attr("class", "outline")
                 .attr("width", width)
                 .attr("height", height);

            // create plot area within svg image
            var plot = svg.append("g")
                .attr("id", "plot")
                .attr("transform", "translate(" + margin + ", " + radius + ")");

            // fix graph links to map to objects instead of indices
            graph.links.forEach(function (d, i) {
                d.src = isNaN(d.source) ? d.source : d.source;
                d.trgt = isNaN(d.target) ? d.target : d.target;
                d.source = isNaN(d.source) ? d.source : graph.nodes[d.source];
                d.target = isNaN(d.target) ? d.target : graph.nodes[d.target];
                d.color = graph.nodes[d.src].color;
               
            });

            // must be done AFTER links are fixed
            linearLayout(graph.nodes);

            // draw links first, so nodes appear on top
            drawLinks(graph.links);

            // draw nodes last
            drawNodes(graph.nodes, svg);
        }

        // Layout nodes linearly, sorted by group
        function linearLayout(nodes) {

            var width = 960;           // width of svg image
            var height = 400;           // height of svg image
            var margin = 20;            // amount of margin around plot area
            var pad = margin / 2;       // actual padding amount
            var radius = 4;             // fixed node radius
            var yfixed = pad + radius;  // y position for all nodes

            // used to scale node index to x position
            var xscale = d3.scale.linear()
                .domain([0, nodes.length - 1])
                .range([radius, width - margin - radius]);

            // calculate pixel location for each node
            nodes.forEach(function (d, i) {
                d.x = xscale(i);
                d.y = yfixed;
            });
        }

        // Draws nodes on plot
        function drawNodes(nodes, svg) {

            var width = 960;           // width of svg image
            var height = 500;           // height of svg image
            var margin = 20;            // amount of margin around plot area
            var pad = margin / 2;       // actual padding amount
            var radius = 5;             // fixed node radius
            var yfixed = pad + radius;  // y position for all nodes

            // used to assign nodes color by group
            var color = d3.scale.category20();

            //Container for the gradients
            var defs = svg.append("defs");

            //Filter for the outside glow
            var filter = defs.append("filter")
                .attr("id", "glow");
            filter.append("feGaussianBlur")
                .attr("stdDeviation", "3.5")
                .attr("result", "coloredBlur");

            var feMerge = filter.append("feMerge");
            feMerge.append("feMergeNode")
                .attr("in", "coloredBlur");
            feMerge.append("feMergeNode")
                .attr("in", "SourceGraphic");

            d3.select("#plot").selectAll(".node")
                .data(nodes)
                .enter()
                .append("circle")
                .attr("class", "node")
                .attr("class", function (d, i) { return "cls" + d.cls })
                .attr("stroke-weight", "1")
                .attr("id", function (d, i) { return d.Name; })
                .attr("cx", function (d, i) { return d.x; })
                .attr("cy", function (d, i) { return d.y; })
                .attr("r", function (d, i) { return radius; })
                .style("fill", function (d, i) { return d.color; })
                .style("cursor", "pointer")
                .on("mouseover", function (d, i) { highlightTip("cls" + d.cls); })
                .on("mouseout", function (d, i) { remhighlightTip("cls" + d.cls); })
                //.on("mouseover", function (d, i) { addTooltip(d3.select(this)); })
                //.on("mouseout", function (d, i) { d3.select("#tooltip").remove(); });

            for (i = 0; i < nodes.length; i++) {
                var tooltip = d3.select("#plot").append("g").append("text")
                    .text(nodes[i].Name)
                    .attr("x", nodes[i].x)
                    .attr("y", nodes[i].y -19)
                    .style("font-size", "larger")
                  
                var offset = tooltip.node().getBBox().width / 2;

                if ((nodes[i].x - offset) < 0) {
                    tooltip.attr("text-anchor", "start");
                    tooltip.attr("dx", -5);
                }
                else if ((nodes[i].x + offset) > (width - margin)) {
                    tooltip.attr("text-anchor", "end");
                    tooltip.attr("dx", -5);
                }
                else {
                    tooltip.attr("text-anchor", "middle");
                    tooltip.attr("dx", 0);
                }
            }
        }

        // Draws nice arcs for each link on plot
        function drawLinks(links) {

            var width = 960;           // width of svg image
            var height = 400;           // height of svg image
            var margin = 20;            // amount of margin around plot area
            var pad = margin / 2;       // actual padding amount
            var radius = 4;             // fixed node radius
            var yfixed = pad + radius;  // y position for all nodes

            // scale to generate radians (just for lower-half of circle)
            var radians = d3.scale.linear()
                .range([Math.PI / 2, 3 * Math.PI / 2]);

            // defining marker
            var defs = d3.select("#plot").append("defs");
            // creating a triangle for arrow
            defs.append("marker")
                .attr({
                    "id": "markerArrow",
                    "refX": "16",
                    "refY": "4",
                    "markerWidth": 8,
                    "markerHeight": 10,
                    "orient": "auto"
                })
                .append("path")
                .attr("d", "M0,4 L8,4 L4,1 L8,4 L4,7")
                .style("fill", "none")
                .style("stroke", "black")
                .style("stroke-width", 1);

            // path generator for arcs (uses polar coordinates)
            var arc = d3.svg.line.radial()
                .interpolate("basis")
                .tension(0)
                .angle(function (d) { return radians(d); });

            var color = d3.scale.category20();

            var lineFunc = d3.svg.line()
                .x(function (d) { return d.x; })
                .y(function (d) { return d.y; })
                .interpolate("linear");

            // add links
            d3.select("#plot").selectAll(".link")
                .data(links)
                .enter()
                .append("path")
                .attr("class", "link")
                .attr("class", function (d, i) { return "cls" + d.source.x })
                .attr("stroke-weight", "1")
                .attr("stroke", function (d, i) { return d.color })
                .attr("transform", function (d, i) {
                    // arc will always be drawn around (0, 0)
                    // shift so (0, 0) will be between source and target
                    var xshift = d.source.x + (d.target.x - d.source.x) / 2;
                    var yshift = yfixed;
                    return "translate(" + xshift + ", " + yshift + ")";
                })
                .attr("d", function (d, i) {
                    //for linear farword lines
                    if (d.trgt - d.src == 1) {
                        return lineFunc([
                            { "x": -95, "y": 1 },
                            { "x": 95, "y": 2 }]);
                    } else {
                        //for reverse or jumper arc lines
                        // get x distance between source and target
                        var xdist = Math.abs(d.source.x - d.target.x);
                        // set arc radius based on x distance
                        arc.radius(xdist / 2);
                        // want to generate 1/3 as many points per pixel in x direction
                        var points = d3.range(0, Math.ceil(xdist / 3));
                        // set radian scale domain
                        radians.domain([0, points.length - 1]);
                        // return path for arc
                        return arc(points);
                    }
                })
                .attr({
                    "fill": "none",
                    "stroke-width": 1,
                    "class": "arrowLine"
                })
                .attr("marker-end", function (d, i) {
                    if (d.trgt - d.src == 1) {
                        return "url(#markerArrow)";
                    }
                    else {
                        return "";
                    }
                })
                .attr("class", function (d, i) {
                    return "cls" + d.source.cls;
                });
        }

        function GetWorkflowTypes() {
            try {
                let jsonResult = {
                    "Types": [
                        { "ID": 1, "Name": "Data Collection" },
                        { "ID": 4, "Name": "Socialization" },
                        { "ID": 3, "Name": "ACTION PLAN" }
                    ]
                };
                var mappedObject = new workflowTypes(JSON.parse(JSON.stringify(jsonResult)));
                WfViewModel.workflowTypes(mappedObject);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetWorkflowTypes() method in WorkflowConfigure.js';
                logger.logMessage(msg);
            }
            

            //try {
            //    $.ajax({
            //        url: "/api/Configuration/WorkflowTypes",
            //        type: "GET",
            //        headers: appsecurity.getSecurityHeaders(),
            //        data: { surveyType: 1 }
            //    })
            //        .success(function (jsonResult, error) {
            //            if (jsonResult !== null) {
            //                if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
            //                    logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(WfViewModel), true);
            //                }
            //                else {
            //                    let jsonResult = {
            //                        "Types": [
            //                            { "ID": 1, "Name": "Data Collection" },
            //                            { "ID": 4, "Name": "Socialization" },
            //                            { "ID": 3, "Name": "ACTION PLAN" }
            //                        ]
            //                    };
            //                    var mappedObject = new workflowTypes(JSON.parse(JSON.stringify(jsonResult)));
            //                    WfViewModel.workflowTypes(mappedObject);
            //                }
            //            }
            //        })
            //        .fail(function (jsonResult, error) {
            //            logger.logError((!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType') == -1) ? (!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType') == -1) ? 'An error has occurred while fetching the dimension types. Please contact your Administrator.' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType')].Name() : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType')].Name(), 'Error', system.getModuleId(WfViewModel), true);
            //            return false;
            //        });
            //}
            //catch (e) {
            //    var msg = 'Exception: ' + e + ' | Source: GetWorkflowDetails() method in BlueprintSetup.js';
            //    logger.logMessage(msg);
            //}
        }
        function workflowTypes(item) {
            try {
                let self = this;

                self.Types = ko.observableArray(item.Types);
                self.selectedType = ko.observable();
                self.selectedType.subscribe(function (newVal) {
                    if (newVal != undefined)
                        GetWorkflowDetails(newVal);
                }, this);

                return self;

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: workflowTypes() method in WorkflowConfigure.js';
                logger.logMessage(msg);
            }
        }

        function GetWorkflowDetails(WF_type) {
            WfViewModel.workflowDetails('');
            WfViewModel.selectedWorkflowType(WF_type);
            try {
                $.ajax({
                    url: "/api/Configuration/WorkflowDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { surveyType: WF_type }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                                logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(WfViewModel), true);
                            }
                            else {
                                var mappedObject = new workflowSetupDetails(JSON.parse(jsonResult));
                                WfViewModel.workflowDetails(mappedObject);
                                
                                GetWorkflowChart(WfViewModel.workflowDetails().nodes, WfViewModel.workflowDetails().links);
                            }
                        }
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError((!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType') == -1) ?
                            (!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType') == -1) ?
                                'An error has occurred while fetching the dimension types. Please contact your Administrator.' :
                                WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType')].Name() :
                            WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType')].Name(),
                            'Error', system.getModuleId(WfViewModel), true);
                        return false;
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetWorkflowDetails() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        
        function workflowSetupDetails(item) {
            try {
                let self = this;
                self.ID = item.ID;
                self.Name = item.Name;

                let arrayPermissions = item.AccessPermissions;
                let arrayEvents = item.Events;
                let arrayLevels = item.Levels;
                let arrayStages = item.Stages;

                //for chart starts here
                self.nodes = item.Stages;
                let arrayEvts = item.Events;
                let arrayStgs = item.Stages;

                let arrayLks = [];
                arrayEvts.filter(item => item.SourceID != item.TargetID)
                    .forEach(function (em) {
                        obj = {
                            source: arrayStgs.find((el) => el.ID == em.SourceID).cls,
                            target: arrayStgs.find((el) => el.ID == em.TargetID).cls
                        }
                        arrayLks.push(obj);
                    });
                self.links = arrayLks;
                //for chart ends here

                let arrayActions = [];
                arrayEvents.filter(item => item.SourceID != item.TargetID) //skip events for same stage. To be used only for Displaying.
                    .forEach(function (item) {
                    var existing = arrayActions.filter(function (v, i) {
                        return v.SourceID == item.SourceID && v.TargetID == item.TargetID;
                    });
                    if (existing.length) {
                        var existingIndex = arrayActions.indexOf(existing[0]);
                        if (item.PermissionID == 0)
                            arrayActions[existingIndex].UserEvent = item;
                        else if (item.PermissionID > 0)
                            arrayActions[existingIndex].AdminEvent = item;
                    } else {
                        obj = {
                            SourceID: item.SourceID,
                            TargetID: item.TargetID,
                            UserEvent: (item.PermissionID == 0) ? item : null,
                            AdminEvent: (item.PermissionID > 0) ? item : null,
                            ActiveStatus: item.Status
                        }
                        arrayActions.push(obj);
                    }
                });

                self.Stages = ko.observableArray(arrayStages.map(obj => {
                    return Object.assign(obj,
                        {
                            OpenLevel: arrayLevels.find((el) => el.StageID == obj.ID && el.WorkingFlag == 0),
                            WorkingLevel: arrayLevels.find((el) => el.StageID == obj.ID && el.WorkingFlag == 1),
                            ReleaseToOthersEvent: arrayEvents.find((el) =>
                                el.SourceID == obj.ID &&
                                el.SourceID == el.TargetID &&
                                el.EventToWorking == 0),
                        });
                }));

                let completeActions = arrayActions.map(obj => {
                    return Object.assign(obj,
                        {
                            Source: arrayStages.find((el) => el.ID == obj.SourceID),
                            Target: arrayStages.find((el) => el.ID == obj.TargetID),
                            AccessPermission: arrayPermissions.find((el) => el.ID == (obj.AdminEvent ? obj.AdminEvent.PermissionID : 0))
                        });
                });
                self.Actions = ko.observableArray(completeActions);

                let filterForStageID = -1;
                self.filterForStage = function (Stage) {
                    if (filterForStageID == Stage.ID) {
                        $('#stage_' + filterForStageID).removeClass('wc-selected-stage');
                        filterForStageID = 0;
                        self.Actions(completeActions);
                    }
                    else {
                        $('#stage_' + filterForStageID).removeClass('wc-selected-stage');
                        $('#stage_' + Stage.ID).addClass('wc-selected-stage');
                        filterForStageID = Stage.ID;
                        self.Actions(completeActions.filter((obj) => { return (obj.SourceID == filterForStageID || obj.TargetID == filterForStageID) }));
                    }
                }
                self.addStagePopup = function (el) {
                    obj = {
                        AJAX_TYPE: 'POST',
                        IS_EDIT_OPEARTION: false,
                        Stage_ID: 0,
                        Stage_Name: '',
                        OpenLevel: { Name: '', PermissionID: ko.observable(true) },
                        WorkingLevel: { Name: '', PermissionID: ko.observable(true) },
                        ReleaseToOthersEvent: { Name: '', PermissionID: 2 }
                    }

                    WfViewModel.StageDetails(new StageModel(obj));
                    $('#addStageModal').modal('show');
                }
                self.editStage = function (el) {
                    obj = {
                        AJAX_TYPE: 'PUT',
                        IS_EDIT_OPEARTION: true,
                        Stage_ID: el.ID,
                        Stage_Name: el.Name,
                        OpenLevel: el.OpenLevel,
                        WorkingLevel: el.WorkingLevel,
                        ReleaseToOthersEvent: (el.ReleaseToOthersEvent ? el.ReleaseToOthersEvent : { Name: '', PermissionID: 2 }) //handling cases without data-fix
                    }
                    WfViewModel.StageDetails(new StageModel(obj));
                    $('#addStageModal').modal('show');
                }
                self.deleteStage = function (el) {
                    obj = {
                        AJAX_TYPE: 'DELETE',
                        IS_EDIT_OPEARTION: true,
                        Stage_ID: el.ID,
                        Stage_Name: el.Name,
                        OpenLevel: el.OpenLevel,
                        WorkingLevel: el.WorkingLevel,
                        ReleaseToOthersEvent: (el.ReleaseToOthersEvent ? el.ReleaseToOthersEvent : { Name: '', PermissionID: 2 }) //handling cases without data-fix
                    }

                    tempStageObject = new ActionModel(obj);
                    app.showMessage((!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreyousuredeleteOrg') == -1) ? 'Are you sure you want to disable the workflow stage?' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreyousuredeleteOrg')].Name(), (!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete') == -1) ? 'Delete' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete')].Name(), [(!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name, (!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name])
                        .then(function (option) {
                            var confirmText = ((!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                            if (option === confirmText) {
                                tempStageObject.SubmitStage();
                            }
                        });
                }
                self.addActionPopup = function (el) {
                    obj = {
                        AJAX_TYPE: 'POST',
                        IS_EDIT_OPEARTION: false,
                        Stages: arrayStages,
                        Actions: arrayActions,
                        AccessPermissions: arrayPermissions
                    }
                    WfViewModel.ActionDetails(new ActionModel(obj));
                    $('#addActionModal').modal('show');
                }
                self.editActionPopup = function (el) {
                    obj = {
                        AJAX_TYPE: 'PUT',
                        IS_EDIT_OPEARTION: true,
                        Name: (el.UserEvent ? el.UserEvent.Name : ""),
                        AdminActionName: (el.AdminEvent ? el.AdminEvent.Name : ""),
                        AdminActionComment: (el.AdminEvent ? el.AdminEvent.Comment : ""),
                        Stages: arrayStages,
                        Actions: arrayActions,
                        AccessPermissions: arrayPermissions,
                        SourceID: el.SourceID,
                        TargetID: el.TargetID,
                        PermissionID: (el.AdminEvent ? el.AdminEvent.PermissionID : 0)
                    }
                    WfViewModel.ActionDetails(new ActionModel(obj));
                    $('#addActionModal').modal('show');
                }
                self.disableAction = function (el) {
                    obj = {
                        AJAX_TYPE: 'DELETE',
                        IS_EDIT_OPEARTION: true,
                        Name: (el.UserEvent ? el.UserEvent.Name : ""),
                        AdminActionName: (el.AdminEvent ? el.AdminEvent.Name : ""),
                        AdminActionComment: (el.AdminEvent ? el.AdminEvent.Comment : ""),
                        Stages: arrayStages,
                        Actions: arrayActions,
                        AccessPermissions: arrayPermissions,
                        SourceID: el.SourceID,
                        TargetID: el.TargetID,
                        PermissionID: (el.AdminEvent ? el.AdminEvent.PermissionID : 0)
                    }

                    tempActionObject = new ActionModel(obj);
                    app.showMessage((!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreyousuredeleteOrg') == -1) ? 'Are you sure you want to disable the workflow action?' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreyousuredeleteOrg')].Name(), (!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete') == -1) ? 'Delete' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete')].Name(), [(!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name, (!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name])
                        .then(function (option) {
                            var confirmText = ((!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                            if (option === confirmText) {
                                tempActionObject.SubmitAction();
                            }
                        });
                }

                return self;
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: workflowSetupDetails() method in WorkflowConfigure.js';
                logger.logMessage(msg);
            }
        }

        function StageModel(item) {
            try {
                let self = this;
                self.AJAX_TYPE = item.AJAX_TYPE;
                self.WFID = WfViewModel.selectedWorkflowType();
                self.IS_EDIT_OPEARTION = item.IS_EDIT_OPEARTION;
                self.ID = item.Stage_ID;
                self.Name = ko.observable(item.Stage_Name);
                self.Roles = ko.observable('');
                self.OpenLevel = item.OpenLevel;
                self.WorkingLevel = item.WorkingLevel;
                self.allowReleaseByUser = ko.observable(item.ReleaseToOthersEvent.PermissionID == 2  ? true : false);
                self.ReleaseToOthersEventName = ko.observable(item.ReleaseToOthersEvent.Name);

                if (!self.IS_EDIT_OPEARTION) {
                    if (self.OpenLevel)
                        self.OpenLevel.Name = ko.computed(function () {
                            return (self.Name() == "" ? "" : self.Name() + " - Pending");
                        }, self); 
                    if (self.WorkingLevel)
                        self.WorkingLevel.Name = ko.computed(function () {
                            return (self.Name() == "" ? "" : self.Name() + " - In Progress");
                        }, self); 
                }
                self.SubmitStage = function () {
                    try {
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        return $.ajax({
                            url: "/api/Configuration/WorkflowStage",
                            type: this.AJAX_TYPE,
                            headers: headers,
                            contentType: 'application/json',
                            dataType: 'json',
                            data: ko.toJSON(this)
                        })
                            .success(function (jsonResult, error) {
                                if (jsonResult !== null) {
                                    if (jsonResult == '1') {
                                        $('#addStageModal').modal('hide');
                                        logger.logSuccess('Workflow Stage has been ' + (this.IS_EDIT_OPEARTION ? 'updated' : 'configured') + ' successfully.', 'Success', system.getModuleId(WfViewModel), true);
                                        GetWorkflowDetails(WfViewModel.selectedWorkflowType());
                                    }
                                    else {
                                        logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(WfViewModel), true);
                                    }
                                }
                                else {
                                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(WfViewModel), true);
                                }
                            })
                            .fail(function (jsonResult, error) {
                                logger.logError((!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType') == -1) ? (!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType') == -1) ? 'An error has occurred while fetching the dimension types. Please contact your Administrator.' : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType')].Name() : WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType')].Name(), 'Error', system.getModuleId(WfViewModel), true);
                                return false;
                            });
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: addStage() method in WorkflowConfigure.js';
                        logger.logMessage(msg);
                    }
                }
                return self;
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: StageModel() method in WorkflowConfigure.js';
                logger.logMessage(msg);
            }
        }

        function ActionModel(item) {
            try {
                let self = this;
                self.AJAX_TYPE = item.AJAX_TYPE;
                self.IS_EDIT_OPEARTION = ko.observable(item.IS_EDIT_OPEARTION);  //default edit else add
                self.WFID = WfViewModel.selectedWorkflowType();
                self.Name = ko.observable(item.Name);
                self.AdminActionName = ko.observable(item.AdminActionName);
                self.AdminActionComment = ko.observable(item.AdminActionComment);
                self.Stages = ko.observableArray(item.Stages);

                self.AccessPermissions = ko.observableArray(item.AccessPermissions);

                self.SourceID = ko.observable(item.SourceID);
                self.TargetID = ko.observable(item.TargetID);
                self.PermissionID = ko.observable(item.PermissionID);
                self.SubmitAction = function () {
                    try {
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        return $.ajax({
                            url: "/api/Configuration/WorkflowAction",
                            type: this.AJAX_TYPE,
                            headers: headers,
                            contentType: 'application/json',
                            dataType: 'json',
                            data: ko.toJSON(this)
                        })
                            .success(function (jsonResult, error) {
                                if (jsonResult !== null) {
                                    if (jsonResult == '1') {
                                        $('#addActionModal').modal('hide');
                                        logger.logSuccess('Workflow Action has been ' + (this.IS_EDIT_OPEARTION ? 'updated' : 'configured') +' successfully.', 'Success', system.getModuleId(WfViewModel), true);
                                        GetWorkflowDetails(WfViewModel.selectedWorkflowType());
                                    }
                                    else {
                                        logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(WfViewModel), true);
                                    }
                                }
                                else {
                                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(WfViewModel), true);
                                }
                            })
                            .fail(function (jsonResult, error) {
                                logger.logError((!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType') == -1) ?
                                    (!WfViewModel.LocaleCheckFlag() || WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType') == -1) ?
                                        'An error has occurred while fetching the dimension types. Please contact your Administrator.' :
                                        WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType')].Name() :
                                    WfViewModel.ObjGeneralSettings.LocalizedTextList()[WfViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType')].Name(),
                                    'Error', system.getModuleId(WfViewModel), true);
                                return false;
                            });
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: SubmitAction() method in WorkflowConfigure.js';
                        logger.logMessage(msg);
                    }
                }

                return self;
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ActionModel() method in WorkflowConfigure.js';
                logger.logMessage(msg);
            }
        }
    });
